import { Injectable } from "@angular/core";

/**
 * Holds a flag indicating that the account-deactivated page may be shown.
 * It is set either when an authenticated user is found to be INACTIVE
 * (mid-session deactivation) or when a sign-in attempt fails because the
 * Cognito account is disabled. The page guard reads this flag to prevent
 * direct navigation to /account-deactivated.
 */
@Injectable({ providedIn: "root" })
export class AccountDeactivatedService {
  /** True once the user has been routed to the account-deactivated page. */
  public signaled = false;
}
